import App from "./App";
import ReactDOM from "react-dom/client";
import ThemeProvider from "./components/Providers/ThemeProvider";
import { AuthProvider } from "./common/auth";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

function ThemedApp() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  );
}

root.render(<ThemedApp />);
